import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from '@mui/material/Alert';
import { StatusBadge } from '@/shared/components/ui/StatusBadge';
import { withdrawalStatusToBadge, formatStatusLabel } from '@/shared/utils/statusBadge';
import { useQuery } from '@tanstack/react-query';
import { adminFinanceApi, adminFinanceKeys } from '@/features/admin-finance/api/admin-finance.api';
import { formatCurrency } from '@/features/guide-finance/utils/formatCurrency';
import { financeListSx, financeRowSx } from '@/features/admin-finance/styles/financeSurfaces';

export function FinanceSettlementsPanel() {
  const { data, isLoading, error } = useQuery({
    queryKey: adminFinanceKeys.settlements({}),
    queryFn: () => adminFinanceApi.listSettlements({ limit: 50 }),
  });

  const settlements = data?.data ?? [];

  return (
    <Box sx={financeListSx}>
      {isLoading && (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
          <CircularProgress size={28} />
        </Box>
      )}
      {error && (
        <Alert severity="error" sx={{ borderRadius: 0, m: 2 }}>
          Failed to load settlements.
        </Alert>
      )}
      {!isLoading && !error && settlements.length === 0 && (
        <Alert severity="info" sx={{ borderRadius: 0, m: 2 }}>
          No settlements yet.
        </Alert>
      )}
      {settlements.map((s) => (
        <Box key={s.id} sx={financeRowSx}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 1.5 }}>
            <Box>
              <Typography fontWeight={700} letterSpacing="-0.02em">
                {formatCurrency(s.grossAmount, s.currency)}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.35 }}>
                Guide {formatCurrency(s.guideAmount)} · Platform {formatCurrency(s.platformAmount)} (
                {s.commissionType === 'PERCENTAGE' ? `${s.commissionValue}%` : 'fixed'})
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Guide {s.guideId.slice(-6)} · {new Date(s.createdAt).toLocaleString()}
              </Typography>
            </Box>
            <StatusBadge
              status={withdrawalStatusToBadge(s.settlementStatus)}
              label={formatStatusLabel(s.settlementStatus)}
              sx={{ borderRadius: 0 }}
            />
          </Box>
        </Box>
      ))}
    </Box>
  );
}
